import { useTranslation } from "react-i18next";
import { fieldErrorText } from "../fieldErrorText";

export default function InputError({ error, children }) {
	const { i18n } = useTranslation();
	const text = error ? fieldErrorText(error, i18n.resolvedLanguage, i18n) : children;
	return <p className="text-sm mt-1.5 text-red-500">{text}</p>;
}
